import React, { useCallback, useEffect, useRef, useState } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Input,
  InputLabel,
  Box,
  TextField,
} from '@mui/material'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { Button } from '@mui/material'
import { useFormik } from 'formik'
import { inject, observer } from 'mobx-react'
import { Tag, Tooltip, Upload, message } from 'antd'
import RichEditor from '../../components/RichEditor/RichEditor'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { LocalizationProvider } from '@mui/x-date-pickers'
import queryString from 'query-string'
import * as Yup from 'yup'
import {
  AiFillBank,
  AiOutlineDelete,
  AiOutlineFolder,
  AiOutlineTeam,
  AiOutlineUpload,
  AiOutlineUser,
} from 'react-icons/ai'
import { ASSIGNEE_TYPE } from '../../utils/constants'
import SelectPeoplePopup from '../../components/SelectPeoplePopup/SelectPeoplePopup'
import SelectGroupPopup from '../../components/SelectGroupPopup/SelectGroupPopup'
import { AvatarHasName } from '../../components/common/Avatar'
import '../../components/RichEditor/RichEditor.scss'
import { MyUploadAdapter } from './../../components/RichEditor/MyUploadAdapter'
import { useNavigate } from 'react-router-dom'
import PopupRenameFile from '../../components/PopupRenameFile/PopupRenameFile'
import utils from '../../utils'
import { WORK_STATUS } from '../../constants'
import moment from 'moment'
import { SelectList } from '../InternalDocumentIncoming/InternalDocumentIncomingDocCreatePageStyled'

const toolbar = [
  'insertTable',
  'Alignment',
  'Autoformat',
  'AutoLink',
  'BlockQuote',
  'Bold',
  'Essentials',
  'FontBackgroundColor',
  'FontColor',
  'FontFamily',
  'FontSize',
  'Heading',
  'Image',
  'ImageInsert',
  'ImageResize',
  'ImageStyle',
  'ImageToolbar',
  'ImageUpload',
  'Indent',
  'IndentBlock',
  'Italic',
  'Link',
  'List',
  'ListStyle',
  'MediaEmbed',
  'MediaEmbedToolbar',
  'Mention',
  'Paragraph',
  'PasteFromOffice',
  'Strikethrough',
  'Table',
  'TableCellProperties',
  'TableProperties',
  'TableToolbar',
  'TextTransformation',
  'TodoList',
  'Underline',
  'WordCount',
]

const CreateModal = props => {
  let {
    params,
    open,
    code,
    loadingAnimationStore,
    handleClose,
    workStore,
    selectPeopleStore,
    fileStore,
    queryStringParsed,
    createMessage,
    setCheck,
    check,
  } = props
  const EDITOR_REF = useRef()
  const [editorState, setEditorState] = useState(null)

  useEffect(() => {
    if (editorState) {
      const editor = editorState
      editor.plugins.get('FileRepository').createUploadAdapter = function (
        loader
      ) {
        return new MyUploadAdapter(loader)
      }

      editor.ui
        .getEditableElement()
        .parentElement.insertBefore(
          editor.ui.view.toolbar.element,
          editor.ui.getEditableElement()
        )

      editor.editing.view.change(writer => {
        writer.setStyle(
          'height',
          '200px',
          editor.editing.view.document.getRoot()
        )
      })
    }
  }, [editorState])
  const [fileExt, setFileExt] = useState(undefined)
  const [fileTargetRename, setFileTargetRename] = useState(null)
  const [fileFromDocumentList, setFileFromDocumentList] = useState([])
  const [handlerList, setHandlerList] = useState([])
  const [followerList, setFollowerList] = useState([])
  const [fileList, setFileList] = useState([])
  const [data, setData] = useState('')
  const [limit, setLimit] = useState(1)
  const [isModalVisibleRenameFile, setIsModalVisibleRenameFile] =
    useState(false)
  const [fieldsRenameFile, setFieldsRenameFile] = useState([
    {
      name: ['rename'],
      value: '',
    },
  ])
  const [isRenameFileUpdate, setIsRenameFileUpdate] = useState(false)
  const {
    selectUserData,
    selectDepartmentData,
    selectGroupData,
    isVisibleSelectGroupPopup,
    setIsVisibleSelectGroupPopup,
    isVisibleSelectUserDepartmentPopup,
    setIsVisibleSelectUserDepartmentPopup,
    handleOpenSelectUserDepartmentPopup,
    handleCancelSelectUserDepartment,
    handleOpenSelectGroupPopup,
    handleCancelSelectGroup,
  } = selectPeopleStore
  useEffect(() => {
    setHandlerList([
      ...selectUserData[ASSIGNEE_TYPE.HANDLER],
      ...selectDepartmentData[ASSIGNEE_TYPE.HANDLER],
      ...selectGroupData[ASSIGNEE_TYPE.HANDLER],
    ])
    setFollowerList([
      ...selectUserData[ASSIGNEE_TYPE.FOLLOWER],
      ...selectDepartmentData[ASSIGNEE_TYPE.FOLLOWER],
      ...selectGroupData[ASSIGNEE_TYPE.FOLLOWER],
    ])
  }, [selectUserData, selectDepartmentData, selectGroupData])

  useEffect(() => {
    const incoming_number = queryStringParsed?.incoming_number || ''
    const title = queryStringParsed?.document_title || ''
    const comments_leader = queryStringParsed?.comments_leader?.length
      ? queryStringParsed?.comments_leader
      : ''
    const leader_name =
      queryStringParsed?.leader_name &&
      queryStringParsed?.comments_leader?.length > 0
        ? `Đ/c ${queryStringParsed?.leader_name}: `
        : ''
    if (queryStringParsed?.document_code) {
      formik.setFieldValue('work_type', WORK_STATUS.DOCUMENT)
      formik.setFieldValue(
        'related_documents',
        queryStringParsed.document_code && queryStringParsed.document_type
          ? [
              {
                code: queryStringParsed.document_code,
                type: queryStringParsed.document_type,
              },
            ]
          : []
      )
      // formik.setFieldValue(
      //   "related_tasks",
      //   queryStringParsed.mission_code && [queryStringParsed.mission_code]
      // );
      formik.setFieldValue(
        'title',
        `Xử lý văn bản ${
          incoming_number ? 'đến ' + incoming_number : 'đi'
        }: ${title}`
      )
      formik.setFieldValue(
        'content',
        `Nội dung: ${title + '. \n'}${leader_name} ${comments_leader}`
      )
      formik.setFieldValue('start_date', moment())
      const files = queryStringParsed?.document_list?.map(file => ({
        file_id: file.split('/')[0],
        file_name: file.split('/').slice(1).join(),
      }))
      setFileFromDocumentList(files)
    }
    if (queryStringParsed?.mission_code) {
      formik.setFieldValue('work_type', WORK_STATUS.DEPLOY)
    }
    if (!formik.values.work_type) {
      formik.setFieldValue('work_type', WORK_STATUS.OTHER)
    }
  }, [])

  const updateAssignees = useCallback(() => {
    const newAssignees = [...followerList, ...handlerList].map(el => ({
      assignee_code: el.id,
      assignee_type: el.assignee_type,
      permission: el.permission,
    }))
    formik.setFieldValue('assignees', handlerList)
  }, [followerList, handlerList])

  const updateAttachments = useCallback(async () => {
    const uploadFileList = fileList.map(file => file.originFileObj)
    const batchUploadArr = []
    uploadFileList.forEach(file => {
      const formData = new FormData()
      formData.append('file', file)
      batchUploadArr.push(fileStore.uploadFile(formData))
    })
    const response = await Promise.all(batchUploadArr)
    const res = response
      .map(response => response.data.file_id)
      .concat(fileFromDocumentList.map(file => file.file_id))
    formik.setFieldValue('attachments', res)
  }, [fileList, fileFromDocumentList])

  useEffect(() => {
    formik.setFieldValue('content', data)
  }, [data])

  useEffect(() => {
    updateAttachments()
    updateAssignees()
    formik.setFieldValue('parent_id', code)
  }, [updateAssignees, updateAttachments])
  const navigate = useNavigate()
  const formik = useFormik({
    initialValues: {
      assignees: {}, // Sử dụng giá trị mới nhất của assignees
      attachments: [],
      content: '',
      start_date: '',
      due_date: '',
      related_documents: [],
      title: '',
      parent_id: '',
      work_type: 'OTHER',
    },
    validationSchema: Yup.object({
      title: Yup.string()
        .required('Vui lòng nhập tiêu đề !')
        .matches(/^(?=.*\S).+$/, 'Vui lòng nhập tiêu đề !'),
      start_date: Yup.string().required('Vui lòng chọn ngày bắt đầu !'),
      // assignees: Yup.array().min(1, 'Vui lòng chọn ít nhất một người xử lý !'),
    }),
    onSubmit: async values => {
      if (handlerList.length === 0) {
        createMessage('Vui lòng chọn người xử lý !', true, 'error')
        return
      }
      setButtonBlock(true)
      try {
        loadingAnimationStore.showSpinner(true)
        await workStore.createWork(values)
        loadingAnimationStore.showSpinner(false)
        createMessage('Tạo công việc thành công!', true, 'success')
      } catch (err) {
        // console.log(err)
      } finally {
        close()
        setLimit(formik.values.current_assignees?.length)
      }
    },
  })

  const close = () => {
    setButtonBlock(false)
    formik.resetForm()
    params({
      page: 0,
      size: 10,
      title: null,
      to_date: null,
      from_date: null,
      status: null,
      permission: null,
    })
    setCheck(!check)
    setData('')

    setAdvanceFilter({
      ...advanceFilter,
      month: '',
    })
    setAdvanceFilterEnd({
      ...advanceFilter,
      month: '',
    })
    setFileFromDocumentList([])
    selectPeopleStore.clearSelected()
    setFileList([])
    setHandlerList([])
    setFollowerList([])
    handleClose()
    workStore.getWorkDetail(code)
  }
  const handleChangeStart = value => {
    if (advanceFilterEnd.month !== null) {
      if (moment(advanceFilterEnd.month.$d).isSameOrAfter(moment(value.$d))) {
        setAdvanceFilter({
          ...advanceFilter,
          month: value,
        })
        formik.setFieldValue('start_date', value)
      } else {
        createMessage(
          'ngày bắt đầu không thể muộn hơn ngày kết thúc, xin vui lòng chọn lại !!!',
          true,
          'error'
        )
      }
    } else {
      setAdvanceFilter({
        ...advanceFilter,
        month: value,
      })
      formik.setFieldValue('start_date', value)
    }
  }
  const handleChangeEnd = value => {
    if (moment(value.$d).isSameOrAfter(moment(advanceFilter.month.$d))) {
      setAdvanceFilterEnd({
        ...advanceFilterEnd,
        month: value,
      })
      formik.setFieldValue('due_date', value)
    } else {
      createMessage(
        'ngày kết thúc không thể sớm hơn ngày bắt đầu, xin vui lòng chọn lại !!!',
        true,
        'error'
      )
    }
  }
  const handleOpenPopupRenameFile = (file, index) => {
    setFieldsRenameFile([
      {
        name: ['rename'],
        value: utils.removeExtensionFile(file.name),
      },
    ])
    setFileExt('.' + utils.getExtensionFile(file.name))
    setFileTargetRename({
      ...file,
      index: index,
    })
    setIsModalVisibleRenameFile(true)
  }
  const [advanceFilter, setAdvanceFilter] = useState({
    date_by: null,
    month: '',
    tag: [],
  })
  const [advanceFilterEnd, setAdvanceFilterEnd] = useState({
    date_by: null,
    month: '',
    tag: [],
  })
  const handleFileChange = useCallback(async info => {
    const filteredFileList = info.fileList.filter(
      (elem, index, fileArray) =>
        fileArray.findIndex(file => file.name === elem.name) === index
    )
    setFileList(filteredFileList)
  }, [])
  const handleRemoveFileFromDocumentList = file_id => {
    const newFileList = fileFromDocumentList.filter(
      file => file.file_id !== file_id
    )
    setFileFromDocumentList(newFileList)
  }
  const handleRemoveFileFromUploadList = fileUID => {
    const newFileList = fileList.filter(file => file.uid !== fileUID)
    setFileList(newFileList)
  }
  const renameFile = (originalFile, newName) => {
    return new File([originalFile], newName, {
      type: originalFile.type,
      lastModified: originalFile.lastModified,
    })
  }
  const submitRenameFile = async value => {
    const index = fileTargetRename?.index
    // đổi tên file nhận từ thiết bị (file chưa ký)
    if (fileTargetRename.originFileObj) {
      const newFileList = [...fileList]
      newFileList[index].name = value.rename + fileExt
      newFileList[index].originFileObj = renameFile(
        newFileList[index].originFileObj,
        newFileList[index].name
      )
      setFileList(newFileList)
      setIsModalVisibleRenameFile(false)
      // message.success('Đổi tên file thành công')
      createMessage('Đổi tên file thành công', true, 'success')
    }
    // đổi tên file nhận từ thiết bị (file đã ký)
    if (!fileTargetRename.originFileObj) {
      await fileStore.handleRenameFile(
        fileTargetRename.id,
        value.rename + fileExt
      )
      setIsModalVisibleRenameFile(false)
      const newFileList = [...fileList]
      newFileList[index].name = value.rename + fileExt
      setFileList(newFileList)
      createMessage('Đổi tên file thành công', true, 'success')
    }
  }

  const [buttonBlock, setButtonBlock] = useState(false)

  return (
    <Dialog
      open={open}
      onClose={close}
      scroll={'paper'}
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
      className="doc-popup"
      fullWidth
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100vw',
            maxWidth: '100vw', // Set your width here
            mx: 0,
            zIndex: 50,
          },
        },
      }}>
      <form onSubmit={formik.handleSubmit}>
        <DialogTitle
          id="scroll-dialog-title"
          className="text-xl font-bold text-[#ffffff] "
          sx={{
            fontWeight: 700,
            backgroundColor: '#2C65AC',
          }}>
          <span className="font-bold">Tạo công việc mới</span>
        </DialogTitle>
        <DialogContent>
          {/* <Box>
            <InputLabel style={{ margin: '5px', color: '#23374D' }}>
              <span className="text-red-500">*</span> Tiêu đề:
            </InputLabel>
            <Inputs
              name="title"
              value={formik.values.title}
              placeholder={'Nhập tiêu đề...'}
              onChange={formik.handleChange}
            />
            {formik.errors.title && formik.touched.title && (
              <p style={{ color: 'red' }}>{formik.errors.title}</p>
            )}
          </Box> */}
          <div style={{ marginTop: 2 }}>
            <TextField
              name="title"
              id="standard-basic"
              label={
                <>
                  <span
                    style={{
                      display: 'inline-block',
                      color: '#ff4d4f',
                      fontSize: '14px',
                      fontFamily: 'SimSun,sans-serif',
                      lineHeight: 1,
                    }}>
                    *
                  </span>
                  <span> Tiêu đề</span>
                </>
              }
              variant="standard"
              sx={{ textAlign: 'center', height: '56px', width: '100%' }}
              value={formik.values?.title}
              onChange={e => {
                formik.handleChange(e)
              }}
              error={formik.errors.title && formik.touched.title ? true : false}
            />
          </div>
          <Box sx={{ paddingBottom: '10px' }}>
            <InputLabel style={{ margin: '5px', color: '#23374D' }}>
              Nội dung:
            </InputLabel>
            <RichEditor
              EDITOR_REF={EDITOR_REF}
              editorContent={formik.values.content}
              setData={setData}
              placeholder={'Nhập nội dung...'}
            />
          </Box>
          <Box sx={{ paddingBottom: '10px' }}>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="vi">
              <DatePicker
                name="start_date"
                label={
                  <>
                    <span
                      style={{
                        display: 'inline-block',
                        color: '#ff4d4f',
                        fontSize: '14px',
                        fontFamily: 'SimSun,sans-serif',
                        lineHeight: 1,
                      }}>
                      *
                    </span>
                    <span> Ngày bắt đầu</span>
                  </>
                }
                openTo="day"
                // views={["day", "month", "year"]}
                value={formik.values.start_date || advanceFilter.month}
                onChange={handleChangeStart}
                inputFormat="DD/MM/YYYY"
                renderInput={params => (
                  <TextField
                    sx={{
                      width: '100%',
                      '& .MuiInputBase-input': {
                        fontSize: '14px',
                      },
                    }}
                    {...params}
                    error={
                      formik.errors.start_date && formik.touched.start_date
                        ? true
                        : false
                    }
                  />
                )}
              />
            </LocalizationProvider>
            {/* {formik.errors.start_date && formik.touched.start_date && (
              <p style={{ color: 'red' }}>{formik.errors.start_date}</p>
            )} */}
          </Box>
          <Box>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="vi">
              <DatePicker
                name="due_date"
                openTo="day"
                label={
                  <>
                    <span> Ngày kết thúc</span>
                  </>
                }
                // views={["day", "month", "year"]}
                value={advanceFilterEnd.month}
                onChange={handleChangeEnd}
                inputFormat="DD/MM/YYYY"
                renderInput={params => (
                  <TextField
                    sx={{
                      width: '100%',
                      '& .MuiInputBase-input': {
                        fontSize: '14px',
                      },
                    }}
                    {...params}
                    helperText={null}
                    error={false}
                    placeholder="-- Chọn ngày kết thúc --"
                  />
                )}
              />
            </LocalizationProvider>
          </Box>
          <Box
            sx={{
              margin: '10px 0',
              display: 'flex',
              alignItems: 'center',
              gap: 1,
            }}>
            <Upload
              valuePropName={'fileList'}
              fileList={fileList}
              multiple={true}
              onChange={handleFileChange}
              beforeUpload={() => false}
              showUploadList={false}>
              <Button variant="contained" className="gap-1">
                <AiOutlineUpload />
                Chọn tài liệu đính kèm
              </Button>
            </Upload>
          </Box>
          {fileFromDocumentList.length !== 0 && (
            <ul
              style={{
                margin: '10px 0 0',
                paddingLeft: '0 !important',
                height: ' auto !important',
                overflow: 'hidden !important',
              }}>
              {fileFromDocumentList.map(file => (
                <li
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginBottom: '8px',
                    transition: 'all ease 0.3s',
                    padding: '3px 0',
                    borderBottom: ' 1px solid #ebebeb',
                    color: '#2C65AC',
                  }}
                  key={file.file_id}>
                  <div className="flex items-center">
                    <AiOutlineFolder className="mr-1 ml-1" />
                    <span
                      onClick={() =>
                        fileStore.handleDownloadFile(
                          file.file_id,
                          file.file_name
                        )
                      }
                      style={{ color: '#1890FF' }}>
                      {file.file_name}
                    </span>
                  </div>
                  <AiOutlineDelete
                    className="text-red-500 ml-2 bg-[rgba(0,115,199,0.07);]"
                    onClick={() =>
                      handleRemoveFileFromDocumentList(file.file_id)
                    }
                  />
                </li>
              ))}
            </ul>
          )}
          {fileList.length !== 0 && (
            <ul
              style={{
                margin: '10px 0 0',
                paddingLeft: '0 !important',
                height: ' auto !important',
                overflow: 'hidden !important',
              }}>
              {fileList.map((file, index) => (
                <li
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginBottom: '8px',
                    transition: 'all ease 0.3s',
                    padding: '3px 0',
                    borderBottom: ' 1px solid #ebebeb',
                    color: '#2C65AC',
                  }}
                  key={file.uid}>
                  <div className="flex items-center">
                    <AiOutlineFolder className="mr-1 ml-1" />
                    <span style={{ color: '#1890FF' }}>{file.name}</span>
                  </div>
                  <div className="flex items-center">
                    <Button
                      className="text-[#1890FF]"
                      style={{ textTransform: 'none' }}
                      onClick={() => {
                        setIsRenameFileUpdate(true)
                        handleOpenPopupRenameFile(file, index)
                      }}>
                      Đổi tên
                    </Button>
                    <AiOutlineDelete
                      className="text-red-500 ml-2 bg-[rgba(0,115,199,0.07);]"
                      onClick={() => handleRemoveFileFromUploadList(file.uid)}
                    />
                  </div>
                </li>
              ))}
            </ul>
          )}
          <Box sx={{ display: 'flex' }}>
            <InputLabel style={{ margin: '5px', color: '#23374D' }}>
              <span className="text-red-500">*</span> Người xử lý:
            </InputLabel>
            <div>
              <Button
                style={{
                  color: '#ffb100',
                  margin: '5px',
                  border: '1px solid blue',
                }}
                onClick={() =>
                  handleOpenSelectUserDepartmentPopup(ASSIGNEE_TYPE.HANDLER)
                }>
                <AiOutlineUser />
              </Button>
              <Button
                style={{
                  color: '#ffb100',
                  margin: '5px',
                  border: '1px solid blue',
                }}
                onClick={() =>
                  handleOpenSelectGroupPopup(ASSIGNEE_TYPE.HANDLER)
                }>
                <AiOutlineTeam />
              </Button>
              <div>
                {handlerList.map(el => (
                  <SelectList>
                    <Tag
                      name="assignees"
                      className={'tag-selected'}
                      color={'blue'}
                      key={el.id}
                      closable
                      onClick={() => selectPeopleStore.handleRemoveSelect(el)}>
                      <AvatarHasName
                        imgId={el.image_id}
                        size={22}
                        name={el.full_name}
                        icon={
                          (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                            <AiFillBank />
                          )) ||
                          (el.assignee_type === ASSIGNEE_TYPE.GROUP && (
                            <AiFillBank />
                          ))
                        }
                      />
                    </Tag>
                  </SelectList>
                ))}
              </div>
            </div>
          </Box>
          {formik.errors.assignees && formik.touched.assignees && (
            <p style={{ color: 'red', fontSize: '12px', marginLeft: '10px' }}>
              {formik.errors.assignees}
            </p>
          )}
          <Box sx={{ display: 'flex' }}>
            <InputLabel style={{ margin: '5px', color: '#23374D' }}>
              Người theo dõi:
            </InputLabel>
            <div>
              <Button
                style={{
                  color: '#ffb100',
                  margin: '5px',
                  border: '1px solid blue',
                }}
                onClick={() =>
                  handleOpenSelectUserDepartmentPopup(ASSIGNEE_TYPE.FOLLOWER)
                }>
                <AiOutlineUser />
              </Button>
              <Button
                style={{
                  color: '#ffb100',
                  margin: '5px',
                  border: '1px solid blue',
                }}
                onClick={() =>
                  handleOpenSelectGroupPopup(ASSIGNEE_TYPE.FOLLOWER)
                }>
                <AiOutlineTeam />
              </Button>
              <div>
                {followerList.map(el => (
                  <SelectList>
                    <Tag
                      className={'tag-selected'}
                      color={'blue'}
                      key={el.id}
                      closable
                      onClick={() => selectPeopleStore.handleRemoveSelect(el)}>
                      <AvatarHasName
                        imgId={el.image_id}
                        size={22}
                        name={el.full_name}
                        icon={
                          (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                            <AiFillBank />
                          )) ||
                          (el.assignee_type === ASSIGNEE_TYPE.GROUP && (
                            <AiFillBank />
                          ))
                        }
                      />
                    </Tag>
                  </SelectList>
                ))}
              </div>
            </div>
          </Box>
        </DialogContent>
        <DialogActions
          sx={{ backgroundColor: '#e3e4e9', position: 'sticky', bottom: '0' }}>
          <Button
            type="button"
            sx={{ fontWeight: 600 }}
            onClick={close}
            className="w-[94px] h-[40px] text-sm font-semibold leading-5 text-primary">
            Đóng
          </Button>
          {buttonBlock ? (
            <button
              disabled={true}
              sx={{ fontWeight: 600 }}
              className="opacity-[0.3] uppercase w-[94px] h-[40px] rounded-[100px] text-sm font-semibold leading-5 text-white bg-[#0073C7]">
              {' '}
              Tạo mới
            </button>
          ) : (
            <button
              type="submit"
              sx={{ fontWeight: 600 }}
              className="uppercase w-[94px] h-[40px] rounded-[100px] text-sm font-semibold leading-5 text-white bg-[#0073C7]">
              {' '}
              Tạo mới
            </button>
          )}
        </DialogActions>
      </form>
      <SelectPeoplePopup
        handleCancelSelectUser={handleCancelSelectUserDepartment}
        handleSubmitSelectUser={() =>
          setIsVisibleSelectUserDepartmentPopup(false)
        }
        isVisibleSelectPeoplePopup={isVisibleSelectUserDepartmentPopup}
      />
      <SelectGroupPopup
        isVisibleSelectGroupPopup={isVisibleSelectGroupPopup}
        handleCancelSelectGroup={handleCancelSelectGroup}
        handleSubmitSelectGroup={() => setIsVisibleSelectGroupPopup(false)}
      />

      <PopupRenameFile
        isModalVisibleRenameFile={isModalVisibleRenameFile}
        handleCloseModalRenameFile={() => setIsModalVisibleRenameFile(false)}
        submitRenameFile={submitRenameFile}
        fieldsRenameFile={fieldsRenameFile}
        fileExt={fileExt}
      />
    </Dialog>
  )
}
export default inject(
  'workStore',
  'loadingAnimationStore',
  'fileStore',
  'selectPeopleStore'
)(observer(CreateModal))
